import { FC } from "react";
import LinearProgress from "@mui/material/LinearProgress";

export const StyledLinearProgress: FC = () => <LinearProgress color="accent" />;
